import { Component, Fragment } from 'react';
import { parse, stringify } from 'query-string';
import { Router } from '../../configs/routes';
import cx from 'classnames';
import Modal from '../modal';
import AmountSelection from '../amountSelection';
import { Api } from '../../api';
import { redirectToLoginPage, showError } from '../../utils';
import { handleTrack, trackAction, trackPixel } from '../../utils/trackActions';
import { createActivity } from '../../utils/leadUtils';
import {
  getSubHeading,
  handleBackNavigation,
  disableBackButton,
  handleBackAction,
} from '../../utils/paymentModalUtils';
import {
  getSuggestedAmountSafely,
  roundOffToStep,
} from '../../utils/commonUtils';
import FundAvatar from '../common/fundAvatar';
import {
  Direction,
  MAX_MF_INVEST_IN_LUMPSUM,
  MAX_MF_INVEST_IN_SIP,
} from '../../constants';

import styles from '../../styles/homePage/topFunds.scss';
import InvestFlowView from '../invest/investFlowView';
import MandateFlowView from '../../components/mandate/mandateFlowView';
import PennyDropView from './pennyDropView';
import { getUserInfoSessionData } from '../../utils/sessionUtil';
import OtpModal from '../dashboard/otpModal';

const api = new Api();

interface State {
  investmentType: string;
  amount: number;
  minAmount: number;
  maxAmount: number;
  query: any;
  startFlow: boolean;
  selectedFund: any;
  disableButton: boolean;
  callbackRequested: boolean;
  message: string;
  hasUserInvestedInProduct: boolean;
  isMaxAmountExceed: boolean;
  isMonthlyLimitExceed: boolean;
  totalActiveSIPAmount: number;
  pennyDropInitiated: boolean;
  bankAccountStatus: any;
  userDetails: any;
  bankErrorMsg: string;
  isTimeOut: boolean;
  isBankVerified: boolean;
  pendingActions: any;
  scheduleLater: boolean;
  otpScreen: boolean;
  otp: string;
  otpEmail: string;
  otpPhone: string;
  isOtpWrong: boolean;
  isOtpVerified: boolean;
  verifyOtpLoader: boolean;
  investmentToken: string;
}

class InvestFlowHandler extends Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      investmentType: '',
      amount: 0,
      minAmount: 0,
      maxAmount: 0,
      query: this.props.url.query || {},
      startFlow: false,
      selectedFund: null,
      disableButton: false,
      callbackRequested: false,
      message: '',
      hasUserInvestedInProduct: false,
      isMaxAmountExceed: false,
      isMonthlyLimitExceed: false,
      totalActiveSIPAmount: 0,
      pennyDropInitiated: false,
      bankAccountStatus: '',
      userDetails: {},
      bankErrorMsg: '',
      isTimeOut: false,
      isBankVerified: false,
      pendingActions: props.pendingActions || [],
      scheduleLater: false,
      otpScreen: false,
      otp: '',
      otpEmail: '',
      otpPhone: '',
      isOtpWrong: false,
      isOtpVerified: false,
      verifyOtpLoader: false,
      investmentToken: '',
    };
  }

  private modal: any;
  private trackingLabel: string = this.props.trackLabel || 'invest_flow';

  public async componentDidMount() {
    this.setInitialState();
  }

  public async componentDidUpdate() {
    const { userInfo } = this.props;
    if (userInfo) {
      const res = await api.getPendingActions();
      if (
        res &&
        JSON.stringify(res.response) !==
          JSON.stringify(this.state.pendingActions)
      ) {
        this.setState({
          pendingActions: res.response,
        });
      }
    }
  }

  public UNSAFE_componentWillReceiveProps(nextProps: any) {
    this.setState({
      query: nextProps.url.query,
    });
    const {
      id: newID,
      suggestedSipAmount,
      suggestedLumpSumAmount,
    } = nextProps.selectedFund;
    const {
      id,
      suggestedSipAmount: oldSipAmount,
      suggestedLumpSumAmount: oldLumpsumAmount,
    } = this.props.selectedFund;
    if (
      newID !== id ||
      suggestedSipAmount !== oldSipAmount ||
      suggestedLumpSumAmount !== oldLumpsumAmount
    ) {
      this.setInitialState(nextProps.selectedFund);
    }
    if (nextProps.pendingActions !== this.state.pendingActions) {
      this.setState({
        pendingActions: nextProps.pendingActions,
      });
    }
  }

  private requestCallback = () => {
    this.setState({ callbackRequested: true });
    trackAction('request-callback', 'invest-sales', 'fund-page');
    createActivity({
      ActivityEvent: 223,
      ActivityNote: 'Request Callback',
    });
  };

  private setInitialState = (updatedFund?: any) => {
    const { selectedFund, url } = this.props;
    let hasUserInvestedInProduct = false;
    let totalActiveSIPAmount = 0;
    let roundOffAmount = 0;
    const productId =
      selectedFund.id !== undefined ? selectedFund.id : selectedFund.productId;
    api.getUserInvestmentInProduct(productId).then((response) => {
      hasUserInvestedInProduct =
        response && response.status === 200 ? true : false;
      this.setState({ hasUserInvestedInProduct });
    });
    api.getTotalSipAmount(productId).then((response) => {
      totalActiveSIPAmount = response ? response : 0;
      this.setState({ totalActiveSIPAmount });
    });
    const { minSipAmount } = selectedFund;
    const { sipEnabled, lumpSumEnabled } = updatedFund || selectedFund;

    let preferredInvestmentMode;
    if (sipEnabled && !lumpSumEnabled) {
      preferredInvestmentMode = 'SIP_MF';
    } else if (!sipEnabled && lumpSumEnabled) {
      preferredInvestmentMode = 'LUMPSUM_MF';
    }

    const minAmount =
      this.state.hasUserInvestedInProduct && selectedFund.minSubsequentAmount
        ? selectedFund.minSubsequentAmount
        : selectedFund.minAmount;
    const lumpsumMultipleAmount =
      (selectedFund && selectedFund.lumpsumMultipleAmount) || 0;
    const { investmentType } = url.query;
    const defaultMinAmount = (url.query && url.query.amount) || 0;
    const defaultItemType = preferredInvestmentMode || Direction.SIP;

    const isSIP = (investmentType || defaultItemType) === Direction.SIP;
    const amount = isSIP ? minSipAmount : minAmount;
    if (minAmount > lumpsumMultipleAmount) {
      roundOffAmount =
        defaultMinAmount <= minAmount
          ? roundOffToStep(minAmount, lumpsumMultipleAmount)
          : roundOffToStep(defaultMinAmount, lumpsumMultipleAmount); // roundoff to lumpsum multiple amount
    } else {
      roundOffAmount =
        defaultMinAmount <= lumpsumMultipleAmount
          ? roundOffToStep(lumpsumMultipleAmount, lumpsumMultipleAmount)
          : roundOffToStep(defaultMinAmount, lumpsumMultipleAmount);
    }

    this.setState({
      investmentType: investmentType || defaultItemType,
      amount: roundOffAmount,
      minAmount: amount,
    });
  };

  private showOtpScreen = async () => {
    this.setState(
      {
        otpScreen: true,
      },
      () => {
        this.generateOtp('NEW_OTP');
      }
    );
  };

  private handleOtpChange = (otp: string) => {
    this.setState({ otp });
  };

  private generateOtp = async (requestType: string) => {
    const { selectedFund } = this.props;
    if (selectedFund) {
      try {
        const productIds = [];
        productIds.push(selectedFund.productId);
        const payload = {
          otpRequestType: requestType,
          productIds,
        };
        const res = await api.handleInvestmentOtp(payload, false);
        if (res) {
          if (res.otpStatus === 'OTP_GENERATION_FAILED') {
            showError(res.description);
          } else if (
            res.otpStatus === 'OTP_GENERATED' ||
            res.otpStatus === 'OTP_REGENERATED'
          ) {
            const { email, phone } = res;
            this.setState({
              otpEmail: email,
              otpPhone: phone,
              isOtpWrong: false,
              otp: '',
            });
          }
        }
      } catch (err) {
        showError(err);
      }
    }
  };

  private verifyOtp = async () => {
    const { selectedFund } = this.props;
    const { otp } = this.state;
    if (selectedFund) {
      this.setState({
        verifyOtpLoader: true,
      });
      try {
        const productIds = [];
        productIds.push(selectedFund.productId);
        const payload = {
          otpRequestType: 'VERIFY_OTP',
          productIds,
          otp,
        };
        const res = await api.handleInvestmentOtp(payload, true);
        if (res) {
          if (res.otpStatus === 'VERIFICATION_FAILED') {
            this.setState({
              verifyOtpLoader: false,
            });
            if (res.otpError === 'WRONG_OTP') {
              this.setState({ isOtpWrong: true });
            } else {
              showError(res.otpError);
            }
          } else if (res.otpStatus === 'VERIFICATION_SUCCEED') {
            this.setState({
              otpScreen: false,
              isOtpVerified: true,
              investmentToken: res.investmentToken,
            });
          }
        }
      } catch (err) {
        showError(err);
      }
    }
  };

  public dismissModal = () => {
    const { onDismiss, redirectUrl } = this.props;
    if (onDismiss) {
      onDismiss();
    }
    if (redirectUrl) {
      const filters = parse(location.search).filters;
      const queries = filters ? `?${stringify({ filters })}` : '';
      Router.pushRoute(`${redirectUrl}${queries}`, { shallow: true });
    } else {
      Router.pushRoute(
        `/save/dashboard/portfolio`,
        '/save/dashboard/portfolio',
        { shallow: true }
      );
    }
  };

  private scheduleModal = () => {
    this.setState({
      scheduleLater: true,
    });
  };

  private dissmissScheduleModal = () => {
    this.setState({
      scheduleLater: false,
    });
  };

  private onEditFunds = () => {
    this.modal.dismiss();
    this.dismissModal();
  };

  private onChangeAmount = () => {
    const {
      query: { fundId },
    } = this.state;

    const path = `/save?fundId=${fundId}`;
    handleTrack({
      label: `${this.trackingLabel}_change_amount`,
      url: path,
    });
    Router.pushRoute(path, path, { shallow: true });
  };

  public startInvestment(selectedFund: any) {
    const { minSipAmount, productId, fundName } = selectedFund;

    this.setState({
      startFlow: true,
      selectedFund,
      amount: minSipAmount,
      minAmount: parseInt(minSipAmount.replace(/[,]/g, ''), 10),
      query: {
        fundId: productId,
      },
    });
    const path = `/save?fundId=${productId}`;
    handleTrack({
      label: `${this.trackingLabel}_${fundName}`,
      url: path,
    });
    Router.pushRoute(path, path, { shallow: true });
  }

  public investClick = (e: any) => {
    e.preventDefault();
    const { isMaxAmountExceed, isMonthlyLimitExceed } = this.state;
    if (isMaxAmountExceed || isMonthlyLimitExceed) {
      return;
    }
    this.setState({ disableButton: true });
    const { sourceType, selectedFund } = this.props;
    const { amount, investmentType, query, maxAmount, totalActiveSIPAmount } =
      this.state;
    const allowedSIPAmount = maxAmount - totalActiveSIPAmount;
    const isMaxMonthlyLimitExceed =
      allowedSIPAmount && amount > allowedSIPAmount ? true : false;

    const { fundName, purchaseMode, alternateProductId } = selectedFund;
    const productId =
      selectedFund.id !== undefined ? selectedFund.id : selectedFund.productId;

    if (productId && productId === 431 && isMaxMonthlyLimitExceed) {
      this.setState({ isMonthlyLimitExceed: true });
      return;
    }
    handleTrack({
      label: `${this.trackingLabel}_${fundName}_amount_selection`,
      value: `{}amount :: ${amount}`,
    });
    createActivity({
      ActivityEvent: 206,
      ActivityNote: 'Plan Selected',
      Fields: [
        {
          SchemaName: 'mx_Custom_1',
          Value: fundName,
        },
        {
          SchemaName: 'mx_Custom_2',
          Value: amount,
        },
        {
          SchemaName: 'mx_Custom_3',
          Value: investmentType,
        },
      ],
    });
    let directId = productId;
    if (purchaseMode === 'REGULAR') {
      directId = alternateProductId;
    }
    const cart = [
      {
        amount: amount.toString().replace(/,/g, ''),
        itemType: investmentType,
        productId: directId,
        referItem: investmentType === Direction.SIP ? null : {},
      },
    ];
    api.updateCart(cart, sourceType, directId).then(() => {
      trackPixel('AddToCart', {
        content_type: 'fund',
        value: directId,
      });

      if (getUserInfoSessionData()) {
        query.detailsSlug = 'first';
        Router.pushRoute(
          `${location.pathname}${location.search}&detailsSlug=first`
        );
      } else {
        redirectToLoginPage();
      }
    });
  };

  public changeState = (key: string, value: any) => {
    /** this is to track fund selection */
    if (key === 'editing' && value) {
      createActivity({ ActivityEvent: 191, ActivityNote: 'top funds' });
    }

    this.setState({
      [key]: value,
    });
  };

  public onChange = (e: any) => {
    const { name, value } = e.target;
    const { amount } = this.state;
    const { minSipAmount } = this.props.selectedFund;
    const { hasUserInvestedInProduct } = this.state;
    const minLumpsumAmount =
      hasUserInvestedInProduct && this.props.selectedFund.minSubsequentAmount
        ? this.props.selectedFund.minSubsequentAmount
        : this.props.selectedFund.minAmount;
    let newAmount = amount;
    if (name === 'amount') {
      const regx = /^\d{1,7}$/; // Allow max value of 7 digits
      if (value === '' || regx.test(value)) {
        const queries = parse(location.search);
        queries.amount = value;
        Router.pushRoute(`${location.pathname}?${stringify(queries)}`, {
          shallow: true,
        });
        this.changeState('amount', value);
      } else {
        return;
      }
    } else if (name === 'investmentType') {
      const isSIP = value === Direction.SIP;
      const minAmount = isSIP ? minSipAmount : minLumpsumAmount;
      const suggestedAmount = getSuggestedAmountSafely(
        this.props.selectedFund,
        isSIP,
        'minSipAmount',
        'minAmount',
        hasUserInvestedInProduct
      );
      if (newAmount < parseInt(minAmount.toString().replace(/[,]/g, ''), 10)) {
        newAmount = suggestedAmount;
      }
      const queries = parse(location.search);
      queries.investmentType = value;
      queries.amount = newAmount;
      Router.pushRoute(`${location.pathname}?${stringify(queries)}`, {
        shallow: true,
      });
      this.setState({
        amount: newAmount,
        investmentType: value,
        minAmount: parseInt(minAmount.toString().replace(/[,]/g, ''), 10),
      });
    } else {
      this.changeState(name, value);
    }
  };

  public onAmountChangeBlur = (e: any) => {
    const val = e.target.value;
    const { minAmount, investmentType, totalActiveSIPAmount } = this.state;
    const {
      lumpsumMultipleAmount,
      maxSipAmount,
      maxLumpsumAmount,
      id,
      productId,
    } = this.props.selectedFund;
    const prodId = id !== undefined ? id : productId;
    const isSIP = investmentType === Direction.SIP;
    const maxAmount = isSIP
      ? maxSipAmount || MAX_MF_INVEST_IN_SIP
      : maxLumpsumAmount || MAX_MF_INVEST_IN_LUMPSUM; // Added max limit, as some fund have this limit as null
    this.setState({
      isMaxAmountExceed: false,
      isMonthlyLimitExceed: false,
      maxAmount,
    });
    let totalAmount;

    // Monthly SIP limit check for Mirae asset emerging bluechip fund
    const allowedSIPAmount = maxAmount - totalActiveSIPAmount;
    const isMaxMonthlyLimitExceed =
      allowedSIPAmount && val > allowedSIPAmount ? true : false;

    if (isSIP && prodId && prodId === 431 && isMaxMonthlyLimitExceed) {
      totalAmount = val;
      this.setState({ isMonthlyLimitExceed: true });
    } else if (maxAmount && val > maxAmount) {
      this.setState({ isMaxAmountExceed: true });
      return;
    } else if (minAmount > lumpsumMultipleAmount) {
      totalAmount =
        val <= minAmount
          ? roundOffToStep(minAmount, lumpsumMultipleAmount)
          : roundOffToStep(val, lumpsumMultipleAmount);
    } else {
      totalAmount =
        val <= lumpsumMultipleAmount
          ? roundOffToStep(lumpsumMultipleAmount, lumpsumMultipleAmount)
          : roundOffToStep(val, lumpsumMultipleAmount);
    }

    this.setState({
      amount: totalAmount,
    });
  };

  public async doPennyDrop(requestObj: any, cb?: any) {
    const { accountNo, ifscCode, cityOfBank, nameOfBank, branchName } =
      requestObj.userBankDetails;
    const bankDetails = {
      accountNo,
      ifscCode,
      cityOfBank,
      nameOfBank,
      branchName,
    };
    let pennyStatusInterval;

    const isTimeoutForPd = setTimeout(() => {
      this.setState({ isTimeOut: true });
      clearInterval(pennyStatusInterval);
    }, 90000);

    const applyPennyDropStatus = () => {
      const { bankAccountStatus } = this.state;
      if (bankAccountStatus.length > 0) {
        clearInterval(pennyStatusInterval);
        clearTimeout(isTimeoutForPd);
      }
      if (bankAccountStatus === 'ACTIVE') {
        setTimeout(() => {
          this.setState(
            { pennyDropInitiated: false, isBankVerified: true },
            () => {
              if (cb) {
                cb(true);
              }
            }
          );
        }, 3000);
      }
    };

    const initPennyResp = await api.initializePennyDrop(bankDetails);

    if (initPennyResp && initPennyResp.success) {
      this.setState(
        {
          pennyDropInitiated: true,
          userDetails: requestObj,
          bankErrorMsg: '',
          bankAccountStatus: '',
        },
        () => {
          pennyStatusInterval = setInterval(async () => {
            const statusResp = await api.getPennyDropStatus(
              accountNo,
              ifscCode
            );
            if (!statusResp.bankAccountStatus) {
              return;
            }
            this.setState(
              {
                bankAccountStatus: statusResp.bankAccountStatus,
              },
              applyPennyDropStatus
            );
          }, 5000);
        }
      );
    } else if (
      initPennyResp &&
      initPennyResp.errorDTO &&
      initPennyResp.errorDTO.message
    ) {
      this.setState({
        bankErrorMsg: initPennyResp.errorDTO.message,
        pennyDropInitiated: false,
      });
    }
  }

  public handleChangeDetails = () => {
    this.setState({
      bankAccountStatus: '',
      pennyDropInitiated: false,
      isTimeOut: false,
    });
  };
  public render() {
    const {
      investmentType,
      query,
      amount,
      minAmount,
      maxAmount,
      callbackRequested,
      isMaxAmountExceed,
      isMonthlyLimitExceed,
      pennyDropInitiated,
      bankAccountStatus,
      userDetails,
      bankErrorMsg,
      isTimeOut,
      isBankVerified,
      pendingActions,
      scheduleLater,
      isOtpVerified,
      otp,
      otpEmail,
      otpPhone,
      otpScreen,
      isOtpWrong,
      verifyOtpLoader,
      investmentToken,
    } = this.state;
    const { selectedFund, entity = {}, userInfo, url } = this.props;
    const isBankPending =
      pendingActions.indexOf('OPS_APPROVAL_PENDING_FOR_BANK_DETAILS') !== -1
        ? true
        : false;

    const isPennyDropPending = pendingActions.includes('PENNY_DROP_NOT_DONE');

    const { userBankDetails = {}, userPersonalDetails = {} } = entity;
    const alreadyInvested = userInfo ? userInfo.alreadyInvested : false;
    // query from state
    const { fundId, detailsSlug } = query;
    // query from props
    const { schedulePayment } = url.query;
    const { supportedItemTypes, purchaseMode } = selectedFund;
    const { sipEnabled, lumpSumEnabled, isinCode } = selectedFund;
    const isPaymentMode = detailsSlug === 'payment';
    const showMandateFLow = schedulePayment ? true : false;
    return (
      <Fragment>
        {(fundId || detailsSlug) && !showMandateFLow ? (
          <div>
            {!isBankPending ? (
              <Modal
                title={
                  !detailsSlug
                    ? 'Amount Selection'
                    : scheduleLater
                    ? 'Schedule order to pay later'
                    : 'Complete Your Investment'
                }
                ref={(modal: any) => (this.modal = modal)}
                subHeadingMessage={
                  pennyDropInitiated
                    ? ''
                    : otpScreen
                    ? 'Verify yourself'
                    : scheduleLater
                    ? 'Schedule order'
                    : getSubHeading(detailsSlug)
                }
                // maxWidth={isPaymentMode ? '1000px' : ''}
                showFooter={!detailsSlug}
                onDismiss={this.dismissModal}
                onSumbit={this.investClick}
                handleBack={() => handleBackAction(detailsSlug)}
                disableBackButton={
                  pennyDropInitiated || otpScreen
                    ? true
                    : disableBackButton(detailsSlug, alreadyInvested)
                }
              >
                {!detailsSlug && fundId ? (
                  <div>
                    {selectedFund ? (
                      <div
                        className={cx(
                          'large-12 small-12 columns',
                          styles['fund-box'],
                          styles['amount-fund']
                        )}
                      >
                        <FundAvatar
                          width={10}
                          fundItem={selectedFund}
                          source="invest-flow-handler"
                        />
                      </div>
                    ) : null}

                    <AmountSelection
                      amount={amount}
                      minAmount={minAmount}
                      onChange={this.onChange}
                      maxAmount={maxAmount}
                      isMaxAmountExceed={isMaxAmountExceed}
                      isMonthlyLimitExceed={isMonthlyLimitExceed}
                      onAmountChangeBlur={this.onAmountChangeBlur}
                      showOkayButton={false}
                      investmentType={investmentType}
                      className="from-home"
                      supportedInvesmtendModes={supportedItemTypes}
                      hideTips
                      callbackRequested={callbackRequested}
                      handleRequestCallBack={this.requestCallback}
                      sipEnabled={sipEnabled}
                      lumpSumEnabled={lumpSumEnabled}
                      isinCode={isinCode}
                      dismissModal={this.dismissModal}
                      purchaseMode={purchaseMode}
                    />
                  </div>
                ) : (
                  <div>
                    {pennyDropInitiated ? (
                      <PennyDropView
                        bankAccountStatus={bankAccountStatus}
                        userDetails={userDetails}
                        handleChangeDetails={this.handleChangeDetails}
                        dismissModal={this.dismissModal}
                        isTimeOut={isTimeOut}
                      />
                    ) : otpScreen ? (
                      <OtpModal
                        otp={otp}
                        handleOtpChange={this.handleOtpChange}
                        phone={otpPhone}
                        email={otpEmail}
                        verifyOtp={this.verifyOtp}
                        generateOtp={this.generateOtp}
                        isOtpWrong={isOtpWrong}
                        numOfInputs={6}
                        verifyOtpLoader={verifyOtpLoader}
                      />
                    ) : (
                      <InvestFlowView
                        bankDetails={userBankDetails}
                        personalDetails={userPersonalDetails}
                        hideEdit={alreadyInvested}
                        parentProps={{ ...this.props }}
                        investmentType={investmentType}
                        handleEditAmount={this.onChangeAmount}
                        onEditFunds={this.onEditFunds}
                        onEdit={this.onEditFunds}
                        isPaymentMode={isPaymentMode}
                        url={url}
                        handleBack={() => {
                          return handleBackNavigation(detailsSlug);
                        }}
                        doPennyDrop={(userDetailsObj, cb) =>
                          this.doPennyDrop(userDetailsObj, cb)
                        }
                        pennyDropPending={isPennyDropPending}
                        bankErrorMsg={bankErrorMsg}
                        isBankVerified={isBankVerified}
                        trackLabel={this.trackingLabel}
                        scheduleLater={scheduleLater}
                        scheduleModal={this.scheduleModal}
                        dissmissScheduleModal={this.dissmissScheduleModal}
                        dismissModal={this.dismissModal}
                        isOtpVerified={isOtpVerified}
                        showOtpScreen={this.showOtpScreen}
                        investmentToken={investmentToken}
                      />
                    )}
                  </div>
                )}
              </Modal>
            ) : (
              <Modal
                title="Documents under review"
                maxWidth=""
                disableBackButton={true}
                onDismiss={this.dismissModal}
                onUnmount={this.dismissModal}
              >
                <div className="pl30 pr30">
                  Dear Investor,
                  <br />
                  <br />
                  Your uploaded documents are currently under review. You can
                  start investing as soon as the documents are verified. Our
                  support team will update the status in next 24-48 hours.
                  Thanks for your patience!
                </div>
              </Modal>
            )}
          </div>
        ) : null}
        {showMandateFLow ? (
          <MandateFlowView
            investmentType={investmentType}
            amount={amount}
            url={this.props.url}
          />
        ) : null}
      </Fragment>
    );
  }
}

export default InvestFlowHandler;



// WEBPACK FOOTER //
// ./components/common/investFlowHandler.tsx